import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-add-user',
  templateUrl: './fh-svg-add-user.component.html',
  styleUrl: './fh-svg-add-user.component.scss'
})
export class FhSvgAddUserComponent {
  @Input() color: string = '';
}
